import type { ModelBase } from './ModelBase';

export const MOVIE_CATEGORY = 'Movie';

export interface Category extends ModelBase {
  name: string;
  priority: number;
  isDeleted?: boolean;
  parentId?: string;
  enabled?: boolean;
  ouId: string;
}
